/* eslint-disable max-len */
import {
  useLocation, NavLink, Link, useNavigate, 
} from 'react-router-dom';
import { useState } from 'react';
import { Button } from '@nazka/nazka.mapframe.components'
import { faCircleUser } from '@fortawesome/pro-solid-svg-icons'
import { useDispatch, useSelector } from 'react-redux';
import { setShowData } from '@templates/T1/t1.redux.actions';
import { setIsCreatingNewDamageLayer } from '@App/components/NewDamageLayer/new-damage-layer.redux.actions';
import { isMobile } from '../Footer/footer.util'; 
import MobileNavbar from './MobileNavbar/MobileNavbar';
import { useAuth } from '../../../components/AuthProvider/auth-provider.context';
import { setUserSelectedMode } from '../../../../library/MaplibreMap/maplibre-map.redux.actions';

import {
  setCurrentSelectedDamageLayer, setShowDamageArea, setSelectedAreaId,
  setShowBuildingDamages,
} from '../../../components/LayerSelector/layer-selector.redux.action';

import './navbar.styl';
import { setComparisonModeStatus, setExitComparisonModeStatus } from '../../../components/BuildingDamages/building-damages.redux.actions';

function Navbar() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { userDetails, isLoggedIn, logOut } = useAuth()
  const location = useLocation();
  const mediaBreakpoint = useSelector(state => state.appWindow.resizeProps.mediaBreakpoint);
  const userSelectedMode = useSelector(state => state.maplibreMap.userSelectedMode);
  const [isOpen, setIsOpen] = useState(false)
  const [isAboutExpanded, setIsAboutExpanded] = useState(false)

  const handleModeSwitch = () => {
    dispatch(setUserSelectedMode(userSelectedMode === 'River flood' ? 'Flash flood' : 'River flood'))
    dispatch(setSelectedAreaId(null))
    dispatch(setShowDamageArea(false))
    dispatch(setCurrentSelectedDamageLayer(null))
    dispatch(setShowBuildingDamages(false))
    dispatch(setShowData(false))
    dispatch(setComparisonModeStatus((false)))
  }
  
  const toggleIsOpen = () => {
    setIsOpen(prevState => !prevState);
  }
  const handleSignOut = () => {
    logOut();
    setIsOpen(prevState => !prevState);
    dispatch(setUserSelectedMode(null))
    dispatch(setShowData(false))
    dispatch(setComparisonModeStatus((false)))
    dispatch(setExitComparisonModeStatus(true))
    dispatch(setCurrentSelectedDamageLayer(null))
    dispatch(setSelectedAreaId(null))
    dispatch(setShowBuildingDamages(false))
    dispatch(setIsCreatingNewDamageLayer(false));
  }

  return (
    <div className="navbar z-depth-1">
      <div className="navbar__betaversion">
        <NavLink to="/" className="navbar__logo">
          <img src="/img/logo/main-logo.png" alt="logo" />
        </NavLink>
  
        {userSelectedMode && (
          <>
            {userSelectedMode === 'River flood' ? (
              <span>
                Flood Damage Estimation
              </span>
            ) : (
       
              <span style={{ marginRight: '10px', width: '80px' }}>Urban runoff simulation</span>
          
            )}
            <Button
              className="navbar__change-mode"
              css={{
                borderRadius: '4px',
              }}
              onClick={handleModeSwitch}
            >
              Change mode
            </Button>
          </>
        )}
        
      </div>
      
      {isMobile(mediaBreakpoint) 
        ? (<MobileNavbar />)
        : (
          <>
            <span style={{ flex: 1 }} />
            <span className="beta-version">Betaversion</span>
            {/* {(location.pathname !== '/') && <NavLink to="/">Map</NavLink>} */}
            {/* <NavLink to="/" className={`${(location.pathname === '/' && isAboutExpanded === false) ? 'active' : ''}`}>Map</NavLink> */}
            <Button
              layout="ghost"
              color="grey"
              hover={false}
              css={{
                fontSize: '18px',
                fontWieght: 'bold',
              }}
              className={`${location.pathname === '/' && !isAboutExpanded ? 'active' : ''}`}
              onClick={() => navigate('/')}
            >
              Map
            </Button>
            <div className="navbar__about-wrapper">
              <Button
                layout="ghost"
                color="grey"
                hover={false}
                css={{
                  fontSize: '18px',
                }}
                className={`about-btn ${location.pathname === '/guides' || isAboutExpanded ? 'active' : ''}`}
              >
                Guides
              </Button>
              <div className="navbar__about-list">
                <Link to="/guides" onClick={() => setIsAboutExpanded(false)} state={{ selection: 'stepbystep' }}>Step-by-step guide</Link>
                <Link to="/guides" onClick={() => setIsAboutExpanded(false)} state={{ selection: 'replication' }}>Replication guide</Link>
                <Link to="/guides" onClick={() => setIsAboutExpanded(false)} state={{ selection: 'bluegreen' }}>Blue-green infrastructure</Link>
              </div>
            </div>
            <Button
              layout="ghost"
              color="grey"
              hover={false}
              css={{
                fontSize: '18px',
                fontWieght: 'bold',
              }}
              className={`${location.pathname === '/contact' && !isAboutExpanded ? 'active' : ''}`}
              onClick={() => navigate('/contact')}
            >
              Contact
            </Button>
            <Button 
              icon={faCircleUser}
              hover={false}
              css={{
                color: '#0367A5',
                backgroundColor: 'white',
                border: 'none',
                padding: '0 0 0 12px',
              }}
              iconProps={{
                size: '26px',
              }}
              onClick={toggleIsOpen}
            />
            {isLoggedIn && isOpen && (
              <div className="navbar__user__detail z-depth-1">
                <div className="navbar__user__detail__elements">
                  <span>{userDetails?.email}</span>
                  <Button
                    className="navbar__user__detail__button"
                    type="submit"
                    css={{
                      marginTop: '10px',
                      width: '100px',
                      borderRadius: '4px',
                    }}
                    onClick={handleSignOut}
                  >
                    Log out
                  </Button>
                </div>
              
              </div>
            )}
            
          </>
        )}
      
    </div>
  )
}

export default Navbar;